var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnixLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4999 0C13.2499 0.438 11.0959 6.47137 9.05189 12.6584C6.03492 21.7874 4.97287 23.9084 3.41689 23.9084C-0.496515 24 -0.496034 24 3.00018 26C4.29417 26.497 4.26488 27.3234 2.97089 30.9914C2.1619 33.2844 1 36.519 1 37C1.99999 37 4.03421 37 7.00018 37C12.4277 37 12.4278 37 12.9278 34.5C13.5007 32.215 14.0079 31.9084 18.9999 31.9084C23.9918 31.9084 24.5 32 25.0889 34.4084C25.9999 37 25.9999 37 30.9999 37C33.9998 37 35.9999 37 36.4998 37C36.4998 36.582 33.8638 27.5164 30.6429 17.8974L24.9999 0.00100283L19.4999 0.00809713C16.4999 0.0068622 14.4999 0 13.4999 0ZM22.5039 24C21.0039 24 15.3477 23.957 15.5039 24C15.5039 24.0449 16.6024 20.4684 17.5024 16.9084L19.2309 9.71983L20.7433 16.9084L22.5039 24ZM30.6429 17.8974C30.8291 18.4539 33.7483 27.2874 30.6429 17.8974C32.9695 24.9083 30.8774 18.6067 30.6429 17.8974C30.1442 16.4083 28.1348 10.4083 30.6429 17.8974C31.9246 21.7722 30.9872 18.936 30.6429 17.8974Z",
    fill: "#FE3C40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnixLogoMobile);
export default __webpack_public_path__ + "static/media/AnixLogoMobile.1f94b02f79b6355113e0fe46b9c0c2e8.svg";
export { ForwardRef as ReactComponent };